import type { FunctionComponent } from 'react';
import { TopNavigation } from '@atlaskit/page-layout';
import NavContents from './NavContents';

const Navigation: FunctionComponent = () => {
  return (
    <TopNavigation>
      <NavContents />
    </TopNavigation>
  );
};

export default Navigation;
